import React from "react";
import ScrollButton from "../ScrollButton/";
import { makeStyles } from '@material-ui/styles'
import { Element } from "react-scroll";
import "./TabsSections.scss";

var showButton = function myFunction() {
  var container = document.getElementById("containerElement");
  var button = document.getElementById("scroll-button");

  if (container.scrollTop < 600 && button.className === ""){
    button.className = "button hidden";
  }
  else if (container.scrollTop > 600) {
    button.className = "button visible";
  }
  else if (button.className === "button visible" && container.scrollTop < 400) {
    button.className = "button visible change";
    setTimeout(()=>{button.className = "button hidden"}, 800);
  }
}

const useStyles = makeStyles({
    normal: {
      fontSize: 11
    },
    bolded: {
      fontSize: 11,
      fontWeight: 'bold'
    },
    degraded: {
      fontSize: 11,
      color: 'rgb(33, 37, 41)'
    },
    container: {
      display: 'flex',
      justifyContent: 'center'
    },
    justify: {
      textAlign: 'justify',
    }
})

function Cookies(props) {

  const classes = useStyles()

  return (
    <div className="panel_content_text">
        <ScrollButton/>
        <Element
            name="test7"
            className="element"
            id="containerElement"
            style={{
                position: "relative",
                height: '60vh',
                overflow: 'scroll',
            }}
            onScroll={showButton}
        >
            {/* <Element name="firstInsideContainer">
                <p className="title">Cookies</p>
            </Element> */}
        
            <p className={classes.container}>
                <strong className={classes.normal}>
                    <u className={classes.bolded}>Política de Cookies</u>
                </strong>
            </p>
            <p className={classes.container}>&nbsp;</p>
            <p className={classes.justify}>
                <span className={classes.normal}>Al igual que otros sitios web, el Sitio https://contactaabogado.com/ utiliza una tecnología denominada “cookies” para recabar información acerca del uso de nuestro sitio web.</span>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <u className={classes.normal}>¿Qué son las cookies?</u>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <span className={classes.normal}>Las cookies son archivos de texto que son descargados automáticamente y almacenados en el disco duro del equipo de cómputo del usuario al navegar en una página de Internet específica, que permiten recordar al servidor de Internet algunos datos sobre
                    este usuario, entre ellos, sus preferencias para la visualización de las páginas en ese servidor, nombre y contraseña. Una cookie es un archivo que se descarga en tu equipo terminal con la finalidad de almacenar datos que podrán ser actualizados
                    y recuperados por la entidad responsable de su instalación.</span>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <u className={classes.normal}>Consentimiento</u>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <span className={classes.normal}>Te informamos de que podemos utilizar cookies en tu equipo a condición de que hayas dado tu consentimiento, salvo en los supuestos en los que las cookies sean necesarias para la navegación por nuestro sitio web y estén exceptuadas de la recogida del
                    consentimiento. En caso de que prestes tu consentimiento, podremos utilizar cookies que nos permitirán tener más información acerca de tus preferencias y personalizar nuestro sitio web de conformidad con tus intereses individuales.&nbsp;</span>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <u className={classes.normal}>¿Para qué se utilizan las cookies en este sitio web?</u>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <span className={classes.normal}>Utilizamos cookies propias y de terceros para mejorar nuestros servicios, personalizar nuestro sitio web, facilitar la navegación de nuestros usuarios, proporcionarte una mejor experiencia en el uso del sitio web, identificar problemas para mejorar
                    el mismo, hacer mediciones y estadísticas de uso y mostrarte publicidad relacionada con tus preferencias mediante el análisis del uso del sitio web.</span>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <span className={classes.normal}>Asimismo, le informamos que se utilizan para obtener información personal de usted, como la siguiente:</span>
            </p>
            <p>
                <br />
            </p>
            <ul>
                <li className={classes.justify}>
                    <span className={classes.normal}>Su tipo de navegador y sistema operativo.</span>
                </li>
                <li className={classes.justify}>
                    <span className={classes.normal}>Las páginas de Internet que visita.</span>
                </li>
                <li className={classes.justify}>
                    <span className={classes.normal}>Los vínculos que sigue.</span>
                </li>
                <li className={classes.justify}>
                    <span className={classes.normal}>La dirección IP.</span>
                </li>
                <li className={classes.justify}>
                    <span className={classes.normal}>El sitio que visitó antes de entrar al nuestro.</span>
                </li>
            </ul>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <u className={classes.normal}>¿Cómo desactivar las cookies?</u>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <span className={classes.normal}>El usuario puede, en cualquier momento, permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la modificación de los parámetros de configuración del navegador instalado en su ordenador:</span>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <ul>
                <li className={classes.justify}>
                    <span className={classes.normal}>Chrome https://support.google.com/chrome/answer/95647?hl=es</span>
                </li>
            </ul>
            <p className={classes.justify}>&nbsp;</p>
            <ul>
                <li className={classes.justify}>
                    <span className={classes.normal}>Explorer&nbsp;https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies#ie=ie-11</span>
                </li>
            </ul>
            <p className={classes.justify}>&nbsp;</p>
            <ul>
                <li className={classes.justify}>
                    <span className={classes.normal}>Firefox [https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias</span>
                </li>
            </ul>
            <p className={classes.justify}>&nbsp;</p>
            <ul>
                <li className={classes.justify}>
                    <span className={classes.normal}>Safari https://support.apple.com/es-mx/guide/safari/sfri11471/mac]</span>
                </li>
            </ul>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <span className={classes.normal}>La desactivación de las cookies no impide la navegación por el sitio web, aunque el uso de algunos de sus servicios podrá ser limitado y, por tanto, su experiencia de navegación podrá ser menos satisfactoria.</span>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <u className={classes.normal}>Protección de Datos</u>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <span className={classes.normal}>Al navegar por el sitio web podemos tratar sus datos personales. Para más información sobre nuestra política de protección de datos sírvase consultar nuestro Aviso de Privacidad.&nbsp;</span>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <u className={classes.normal}>Retirar el Consentimiento</u>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <span className={classes.normal}>El usuario podrá retirar en cualquier momento su consentimiento relacionado con la Política de Cookies, y podrá eliminar las cookies almacenadas en su equipo a través de los ajustes y configuraciones de su navegador de Internet, indicados anteriormente.</span>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <u className={classes.normal}>Cambios en la Política de Cookies</u>
            </p>
            <p className={classes.justify}>&nbsp;</p>
            <p className={classes.justify}>
                <span className={classes.normal}>La presente Política de Cookies se podrá modificar cuando así lo exija la legislación vigente en cada momento o cuando hubiera alguna variación en el tipo de cookies utilizadas en el sitio web. Por ello, te recomendamos revisar esta política cada
                    vez que accedas a nuestro sitio web con el objetivo de estar adecuadamente informado sobre cómo y para qué usamos las cookies.</span>
            </p>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>

        </Element>
    </div>
  );
}

export default Cookies;